<app-header></app-header>

<div class="page-content">

  <div class="mobile-body-container">
    <!-- IMAGE -->
    <!-- <div class="login-image-container">
      <div class="card-image">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ef03b7f9-6c3f-4067-c459-00ec5eb56900/public" alt="">
      </div>
    </div> -->

    <!-- IMAGE NO CARD -->
    <!-- <div class="login-image-container">
      <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ef03b7f9-6c3f-4067-c459-00ec5eb56900/public" alt="">
    </div> -->

    <div form [formGroup]="signin">
      <h1 class="webapp-title nomargin">{{'AUTH.LOGIN.TITLE' | translate}}</h1>
      <!-- <p>Accede a tu app de usuario</p> -->
      <mat-card-content>

        <mat-form-field class="my-mat-form-field">
          <mat-label>{{'AUTH.REGISTER.EMAIL_PLACEHOLDER' | translate}}</mat-label>
          <input matInput placeholder="{{getTranslationFor('AUTH.LOGIN.EMAIL_PLACEHOLDER')}}" class="my-mat-fields" type="email" required formControlName="username" (keyup.enter)="onKeyUp($event)">
        </mat-form-field>

        <!-- PASS -->
        <mat-form-field class="my-mat-form-field"> 
          <mat-label>{{'AUTH.LOGIN.PASSWORD_LABEL' | translate}}</mat-label>
          <input matInput placeholder="{{getTranslationFor('AUTH.LOGIN.PASSWORD_PLACEHOLDER')}}" class="my-mat-fields" formControlName="password" [type]="hide ? 'password' : 'text'" required (keyup.enter)="onKeyUp($event)">
          <mat-icon matSuffix (click)="hide = !hide" style="align-items: center;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </mat-form-field>
      </mat-card-content>

      <div class="flex-col">
        <!-- BUTTON -->
        <button (click)="login()" mat-button class="button button-fill color-dark button-round" [disabled]="!areFieldsFilled()">
          <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isLoading()"></mat-spinner>
          <span *ngIf="!isLoading()">{{'AUTH.LOGIN.LOGIN_BUTTON' | translate}}</span>
        </button>
        <button class="button button-fill color-light button-round" mat-button routerLink="/register">{{'AUTH.LOGIN.REGISTER_NOW' | translate}}</button>
        <button class="button button-fill button-round" mat-button routerLink="/recover-password">{{'AUTH.LOGIN.FORGOT_PASSWORD' | translate}}</button>
      </div>
    </div>

  </div>
  
</div>